__webpack_public_path__ = window.ORW?.appUrl.replace(/assets\/$/, '');
